module.exports = __webpack_public_path__ + "static/media/1-en.d1feb1b9.svg";